export default __webpack_public_path__ + "static/media/toolkit.271a51df.svg";